import {
  ControlPosition,
  InfoWindow,
  MapControl,
  useMap,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import { ConfigOperationsContext } from ".";
import { parseGeographyToCoordinates } from "../utils/apiUtils";
import { Card, Stack, TextField, Typography } from "@mui/material";
import { Image } from "antd";
import { notiError } from "../utils/notiUltils";

function MapOverlays() {
  const map = useMap();
  const maps = useMapsLibrary("maps");
  const core = useMapsLibrary("core");
  //const drawing = useMapsLibrary("drawing");
  const {
    datagGoFences,
    overlaySelected,
    api,
    editSelected,
    setCore,
    drawingMode,
    operation,
    setDrawnOverlay,
  } = useContext(ConfigOperationsContext);

  const [positionOfInfoWindow, setPositionOfInfoWindow] = useState(null);
  const [position, setPosition] = useState("");
  const [markerInfo, setMarkerInfo] = useState(null);

  const circleRef = useRef(null);
  const polylineRef = useRef(null);
  const pathRef = useRef([]);
  const startPointRef = useRef(null);
  const rectangleRef = useRef(null);
  const polygonRef = useRef(null);
  const pointsRef = useRef([]);

  const drawingRef = useRef(false);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const latLngRegex =
        /^\s*[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)\s*$/;
      if (latLngRegex.test(position)) {
        const arrPosition = position.split(",");
        setMarkerInfo(
          new maps.InfoWindow({
            position: {
              lat: parseFloat(arrPosition[0]),
              lng: parseFloat(arrPosition[1]),
            },
            headerContent: "Current Point",
            content: arrPosition.join(","),
          }),
        );
        setPosition("");
      } else {
        notiError({ message: "พิกัดไม่ถูกต้อง", position: "bottom-right" });
      }
    }
  };

  useEffect(() => {
    if (!markerInfo || !map) {
      return;
    }
    markerInfo.setMap(map);
    map.setCenter({
      lat: markerInfo.position.lat(),
      lng: markerInfo.position.lng(),
    });

    return () => {
      markerInfo.setMap(null);
    };
  }, [markerInfo, map]);

  useEffect(() => {
    setMarkerInfo(null);
  }, [operation]);

  useEffect(() => {
    if (!map || !maps || !datagGoFences) {
      return;
    }
    datagGoFences.forEach((geoFence) => {
      const { Radius, GeotypeID, WKT, Latitude, Longitude } = geoFence;
      switch (GeotypeID) {
        case 1:
          const circle = new maps.Circle({
            center: { lat: Latitude, lng: Longitude },
            radius: Radius,
            fillColor: "#1976D2",
            strokeColor: "#1976D2",
            strokeWeight: 1,
          });
          circle.setMap(map);
          geoFence.overlay = circle;
          break;
        case 2:
        case 4:
          const paths = parseGeographyToCoordinates(WKT);
          const polygon = new maps.Polygon({
            paths,
            radius: Radius,
            fillColor: "#1976D2",
            strokeColor: "#1976D2",
            strokeWeight: 1,
          });
          polygon.setMap(map);
          geoFence.overlay = polygon;
          break;
        case 3:
          const flightPlanCoordinates = parseGeographyToCoordinates(WKT);
          const flightPath = new maps.Polyline({
            path: flightPlanCoordinates,
            geodesic: true,
            strokeColor: "#1976D2",
            strokeOpacity: 1.0,
            strokeWeight: 2,
          });
          flightPath.setMap(map);
          geoFence.overlay = flightPath;
          break;
        default:
          break;
      }
    });
    return () => {
      datagGoFences.forEach((geoFence) => {
        const { overlay } = geoFence;
        overlay?.setMap(null);
      });
    };
  }, [map, maps, datagGoFences]);

  useEffect(() => {
    if (!overlaySelected || !maps || !core || !map) {
      return;
    }
    const { overlay } = overlaySelected;

    (overlay instanceof maps.Polygon ||
      overlaySelected instanceof maps.Rectangle ||
      overlay instanceof maps.Circle) &&
      overlay?.setOptions({ fillColor: "green" });

    overlay instanceof maps.Polyline &&
      overlay?.setOptions({ strokeColor: "green" });

    if (
      overlay instanceof maps.Polygon ||
      overlay instanceof maps.Rectangle ||
      overlay instanceof maps.Polyline
    ) {
      const bounds = new core.LatLngBounds();
      const path = overlay?.getPath();
      for (let i = 0; i < path.getLength(); i++) {
        bounds.extend(path.getAt(i));
      }
      if (overlay instanceof maps.Polyline) {
        const index = Math.floor(path.getLength() / 2);
        const center = path.getAt(index);
        setPositionOfInfoWindow(center);
      } else {
        const center = bounds.getCenter();
        setPositionOfInfoWindow(center);
      }
      map.fitBounds(bounds);
    } else if (overlay instanceof maps.Circle) {
      const bounds = overlay?.getBounds();
      const center = bounds.getCenter();
      setPositionOfInfoWindow(center);
      map.fitBounds(bounds);
    }

    return () => {
      (overlay instanceof maps.Polygon ||
        overlay instanceof maps.Rectangle ||
        overlay instanceof maps.Circle) &&
        overlay?.setOptions({ fillColor: "#1976D2" });

      overlay instanceof maps.Polyline &&
        overlay?.setOptions({ strokeColor: "#1976D2" });

      setPositionOfInfoWindow(null);
    };
  }, [overlaySelected, maps, core, map]);

  useEffect(() => {
    if (!editSelected || !map || !maps || !core) {
      return;
    }
    const { overlay } = editSelected;
    overlay?.setMap(null);
    if (overlay instanceof maps.Circle) {
      const circleOptions = {
        strokeColor: overlay.get("strokeColor"),
        strokeOpacity: overlay.get("strokeOpacity"),
        strokeWeight: overlay.get("strokeWeight"),
        fillColor: "#FF0000",
        fillOpacity: overlay.get("fillOpacity"),
        center: overlay.getCenter(),
        radius: overlay.getRadius(),
        map: map,
        editable: true,
        draggable: true,
      };
      editSelected.overlayEdit = new maps.Circle(circleOptions);
      map.fitBounds(overlay?.getBounds());
    }

    if (overlay instanceof maps.Polygon || overlay instanceof maps.Rectangle) {
      const paths = overlay
        .getPaths()
        .getArray()
        .map((path) =>
          path
            .getArray()
            .map((latLng) => ({ lat: latLng.lat(), lng: latLng.lng() })),
        );
      const circleOptions = {
        paths: paths,
        strokeColor: overlay.get("strokeColor"),
        strokeOpacity: overlay.get("strokeOpacity"),
        strokeWeight: overlay.get("strokeWeight"),
        fillColor: "#FF0000",
        fillOpacity: overlay.get("fillOpacity"),
        map: map,
        editable: true,
        draggable: true,
      };
      editSelected.overlayEdit = new maps.Polygon(circleOptions);
      const bounds = new core.LatLngBounds();
      const path = overlay?.getPath();
      for (let i = 0; i < path.getLength(); i++) {
        bounds.extend(path.getAt(i));
      }
      map.fitBounds(bounds);
    }

    if (overlay instanceof maps.Polyline) {
      const path = overlay
        .getPath()
        .getArray()
        .map((latLng) => ({ lat: latLng.lat(), lng: latLng.lng() }));
      const polylineOptions = {
        path: path,
        geodesic: overlay.get("geodesic"),
        strokeColor: "#FF0000",
        strokeOpacity: overlay.get("strokeOpacity"),
        strokeWeight: overlay.get("strokeWeight"),
        map: map,
        editable: true,
        draggable: true,
      };
      editSelected.overlayEdit = new maps.Polyline(polylineOptions);
      const bounds = new core.LatLngBounds();
      const paths = overlay?.getPath();
      for (let i = 0; i < paths.getLength(); i++) {
        bounds.extend(paths.getAt(i));
      }
      map.fitBounds(bounds);
    }

    return () => {
      overlay?.setMap(map);
      editSelected?.overlayEdit?.setMap(null);
      map.setZoom(13);
    };
  }, [editSelected, maps, core, map]);

  useEffect(() => {
    if (!core || !setCore) {
      return;
    }
    setCore(core);
  }, [core, setCore]);

  /*useEffect(() => {
    if (!map || !maps || !setDrawnOverlay) return;

    if (drawingMode === 1) {
      const clickListener = map.addListener("click", (e) => {
        if (!e.latLng) return;

        // คลิกครั้งแรก
        if (!drawing) {
          if (circleRef.current) return;
          centerRef.current = e.latLng;
          setDrawing(true);

          circleRef.current = new maps.Circle({
            map,
            center: e.latLng,
            radius: 0,
            editable: true,
            draggable: false,
            strokeWeight: 1,
            fillOpacity: 0.25,
            clickable: false,
          });

          return;
        }

        // คลิกครั้งที่สอง => จบการวาด
        setDrawing(false);

        if (circleRef.current) {
          circleRef.current.setEditable(true);
          circleRef.current.setDraggable(true);
        }
      });

      const moveListener = map.addListener("mousemove", (e) => {
        if (!drawing) return;
        if (!centerRef.current) return;
        if (!circleRef.current) return;
        if (!e.latLng) return;

        const radius =
          window.google.maps.geometry.spherical.computeDistanceBetween(
            centerRef.current,
            e.latLng,
          );

        circleRef.current.setRadius(radius);
        setDrawnOverlay(circleRef.current);
      });

      return () => {
        clickListener.remove();
        moveListener.remove();
      };
    }

    if (drawingMode === 3) {
      if (drawing) setDrawing(false);
      if (circleRef.current) {
        circleRef.current.setMap(null);
        circleRef.current = null;
      }
      setDrawnOverlay(null);

      drawingRef.current = true;
      pathRef.current = [];
      polylineRef.current?.setMap(null);

      polylineRef.current = new maps.Polyline({
        map,
        path: [],
        editable: false,
        draggable: false,
        clickable: false,
        strokeColor: "#FF0000",
        strokeWeight: 3,
      });

      map.setOptions({
        draggableCursor: "crosshair",
      });

      map.setOptions({
        disableDoubleClickZoom: true,
      });

      const clickListener = map.addListener("click", (e) => {
        if (!drawingRef.current) return;
        const point = {
          lat: e.latLng.lat(),
          lng: e.latLng.lng(),
        };

        pathRef.current.push(point);

        polylineRef.current?.setPath(pathRef.current);
      });

      const moveListener = map.addListener("mousemove", (e) => {
        if (!drawingRef.current) return;

        if (pathRef.current.length === 0) return;

        const previewPath = [
          ...pathRef.current,
          {
            lat: e.latLng.lat(),
            lng: e.latLng.lng(),
          },
        ];

        polylineRef.current?.setPath(previewPath);
      });

      const dblClickListener = map.addListener("dblclick", () => {
        if (!drawingRef.current) return;

        drawingRef.current = false;

        polylineRef.current?.setPath(pathRef.current);

        polylineRef.current?.setEditable(true);

        polylineRef.current?.setDraggable(true);

        map.setOptions({
          draggableCursor: "grab",
        });

        setDrawnOverlay(polylineRef.current);
      });

      setDrawing(false);

      return () => {
        clickListener.remove();
        moveListener.remove();
        dblClickListener.remove();
        map.setOptions({
          disableDoubleClickZoom: false,
        });
      };
    }

    if (drawingMode === null) {
      if (circleRef.current) {
        circleRef.current.setMap(null);
        circleRef.current = null;
      }
      setDrawnOverlay(null);
    }
  }, [map, drawing, drawingMode, maps, setDrawnOverlay]);*/

  /*useEffect(() => {
    if (!map || !core || !maps) return;

    const draw = new TerraDraw({
      adapter: new TerraDrawGoogleMapsAdapter({
        map,
        lib: window.google.maps,
      }),
      modes: [
        new TerraDrawSelectMode(),
        new TerraDrawPolygonMode(),
        new TerraDrawRectangleMode(),
        new TerraDrawCircleMode(),
        new TerraDrawLineStringMode(),
      ],
    });

    draw.on("finish", (id) => {
      draw.setMode("select");
    });

    console.log(drawingMode);

    
    switch (drawingMode) {
      case 1:
        draw.start();
        draw.setMode("circle");
        break;
      default:
        //draw.start();
        //draw.setMode("select");
        break;
    }

    return () => {
      if (drawingMode) {        
        draw.setMode("select");
      }
      draw.stop();
    };
  }, [map, core, drawingMode, maps]);*/

  /*useEffect(() => {
    if (!map || !drawing) {
      return;
    }
    const newDrawingManager = new drawing.DrawingManager({
      map,
      drawingMode: null,
      drawingControl: false,
      drawingControlOptions: {
        position: ControlPosition.TOP_CENTER,
        drawingModes: [
          drawing.OverlayType.CIRCLE,
          drawing.OverlayType.POLYGON,
          drawing.OverlayType.POLYLINE,
          drawing.OverlayType.RECTANGLE,
        ],
      },
      circleOptions: {
        editable: true,
        clickable: true,
        fillColor: "#FF0000",
        strokeColor: "#FF0000",
        strokeWeight: 1,
      },
      polygonOptions: {
        editable: true,
        draggable: true,
        fillColor: "#FF0000",
        strokeColor: "#FF0000",
      },
      rectangleOptions: {
        editable: true,
        draggable: true,
        fillColor: "#FF0000",
        strokeColor: "#FF0000",
        strokeWeight: 1,
      },
      polylineOptions: {
        editable: true,
        draggable: true,
        fillColor: "#FF0000",
        strokeColor: "#FF0000",
      },
    });

    newDrawingManager.setDrawingMode(
      drawingMode === 1
        ? drawing.OverlayType.CIRCLE
        : drawingMode === 2
        ? drawing.OverlayType.POLYGON
        : drawingMode === 3
        ? drawing.OverlayType.POLYLINE
        : drawingMode === 4
        ? drawing.OverlayType.RECTANGLE
        : null
    );

    let overlay;
    setDrawnOverlay(null);
    const overlaycomplete = (event) => {
      overlay = event.overlay;
      setDrawnOverlay(overlay);
      newDrawingManager.setDrawingMode(null);
    };
    newDrawingManager.addListener("overlaycomplete", overlaycomplete);

    return () => {
      newDrawingManager.setMap(null);
      overlay?.setMap(null);
    };
  }, [drawingMode, drawing, map, setDrawnOverlay]);*/

  useEffect(() => {
    if (!map || !maps) return;

    //clear overlay
    if (circleRef) circleRef.current?.setMap(null);
    if (polylineRef) polylineRef.current?.setMap(null);
    if (rectangleRef) rectangleRef.current?.setMap(null);
    if (polygonRef) polygonRef.current?.setMap(null);
    circleRef.current = null;
    polylineRef.current = null;
    rectangleRef.current = null;
    polygonRef.current = null;
    startPointRef.current = null;

    drawingRef.current = false;
    map.setOptions({
      disableDoubleClickZoom: false,
    });

    if (drawingMode === null) {
      map.setOptions({
        draggableCursor: "grab",
      });
      return;
    } else {
      map.setOptions({
        draggableCursor: "crosshair",
      });
    }

    switch (drawingMode) {
      case 1:
        const clickListener = map.addListener("click", (e) => {
          if (!e.latLng) return;
          if (!drawingRef.current) {
            if (circleRef.current) return;
            drawingRef.current = true;
            circleRef.current = new maps.Circle({
              map,
              center: e.latLng,
              radius: 0,
              editable: true,
              draggable: false,
              strokeWeight: 1,
              fillOpacity: 0.25,
              clickable: false,
            });
            circleRef.current.addListener("click", (e) => {
              window.google.maps.event.trigger(map, "click", {
                latLng: e.latLng,
              });
            });
            return;
          }
          drawingRef.current = false;
          if (circleRef.current) {
            circleRef.current.setEditable(true);
            circleRef.current.setDraggable(true);
          }
          map.setOptions({
            draggableCursor: "grab",
          });
        });

        const moveListener = map.addListener("mousemove", (e) => {
          if (!drawingRef.current || !circleRef.current || !e.latLng) return;
          const radius =
            window.google.maps.geometry.spherical.computeDistanceBetween(
              circleRef.current.center,
              e.latLng,
            );
          circleRef.current.setRadius(radius);
          setDrawnOverlay(circleRef.current);
        });

        return () => {
          clickListener.remove();
          moveListener.remove();
        };
      case 2:
        map.setOptions({
          disableDoubleClickZoom: true,
        });
        pointsRef.current = [];
        const polyline = new maps.Polyline({
          map,
          path: [],
          editable: false,
          draggable: false,
          clickable: false,
          strokeColor: "#ff000060",
          strokeWeight: 3,
        });
        const polylineCurrent = new maps.Polyline({
          map,
          path: [],
          editable: true,
          draggable: false,
          clickable: false,
          strokeColor: "#ff0000",
          strokeWeight: 3,
        });
        polylineCurrent.addListener("click", (e) => {
          window.google.maps.event.trigger(map, "click", {
            latLng: e.latLng,
          });
        });
        polygonRef.current = new maps.Polygon({
          map,
          paths: [],
          editable: true,
          draggable: true,
          //strokeColor: "#FF0000",
          strokeWeight: 1,
          //fillColor: "#FF0000",
          fillOpacity: 0.2,
        });
        map.setOptions({
          draggableCursor: "crosshair",
          disableDoubleClickZoom: true,
        });
        drawingRef.current = true;

        const tempPoint = [];

        const clickListener2 = map.addListener("click", (e) => {
          if (!drawingRef.current) return;
          tempPoint.length = 0;

          if (pointsRef.current.length > 2) {
            const firstPoint = pointsRef.current[0];
            const distance =
              window.google.maps.geometry.spherical.computeDistanceBetween(
                e.latLng,
                firstPoint,
              );

            const zoom = map.getZoom();
            const tolerance = 100 / Math.pow(2, zoom - 15);
            if (distance < tolerance) {
              drawingRef.current = false;
              pointsRef.current.push(firstPoint);
              polygonRef.current?.setPaths(pointsRef.current);
              setDrawnOverlay(polygonRef.current);
              polyline.setMap(null);
              polylineCurrent.setMap(null);
              tempPoint.length = 0;
              map.setOptions({
                draggableCursor: "grab",
                disableDoubleClickZoom: false,
              });
            } else {
              pointsRef.current.push({
                lat: e.latLng.lat(),
                lng: e.latLng.lng(),
              });
            }
          } else {
            pointsRef.current.push({
              lat: e.latLng.lat(),
              lng: e.latLng.lng(),
            });
          }

          tempPoint.push({
            lat: e.latLng.lat(),
            lng: e.latLng.lng(),
          });
          polyline.setPath(tempPoint);
          polylineCurrent.setPath(pointsRef.current);
        });

        const moveListener2 = map.addListener("mousemove", (e) => {
          if (!drawingRef.current) return;
          if (tempPoint.length === 0) return;

          const firstPoint = pointsRef.current[0];

          const distance =
            window.google.maps.geometry.spherical.computeDistanceBetween(
              e.latLng,
              firstPoint,
            );

          const zoom = map.getZoom();
          const tolerance = 100 / Math.pow(2, zoom - 15);

          const preview = [
            ...tempPoint,
            distance < tolerance
              ? firstPoint
              : {
                  lat: e.latLng.lat(),
                  lng: e.latLng.lng(),
                },
          ];

          polyline.setPath(preview);
        });

        return () => {
          clickListener2.remove();
          moveListener2.remove();
          polyline.setMap(null);
          polylineCurrent.setMap(null);
          polygonRef.current?.setMap(null);
          polygonRef.current = null;
        };
      case 3:
        map.setOptions({
          disableDoubleClickZoom: true,
        });
        drawingRef.current = true;
        pathRef.current = [];
        polylineRef.current = new maps.Polyline({
          map,
          path: [],
          editable: false,
          draggable: false,
          clickable: false,
          strokeColor: "#FF0000",
          strokeWeight: 3,
        });

        const clickListener3 = map.addListener("click", (e) => {
          if (!drawingRef.current) return;
          const point = {
            lat: e.latLng.lat(),
            lng: e.latLng.lng(),
          };

          pathRef.current.push(point);

          polylineRef.current?.setPath(pathRef.current);
        });

        const moveListener3 = map.addListener("mousemove", (e) => {
          if (!drawingRef.current) return;
          if (pathRef.current.length === 0) return;
          const previewPath = [
            ...pathRef.current,
            {
              lat: e.latLng.lat(),
              lng: e.latLng.lng(),
            },
          ];
          polylineRef.current?.setPath(previewPath);
        });

        const dblClickListener3 = map.addListener("dblclick", () => {
          if (!drawingRef.current) return;
          drawingRef.current = false;
          polylineRef.current?.setPath(pathRef.current);
          polylineRef.current?.setEditable(true);
          polylineRef.current?.setDraggable(true);
          map.setOptions({
            draggableCursor: "grab",
          });
          setDrawnOverlay(polylineRef.current);
        });

        return () => {
          clickListener3.remove();
          moveListener3.remove();
          dblClickListener3.remove();
        };
      case 4:
        const clickListener4 = map.addListener("click", (e) => {
          if (!e.latLng) return;
          if (!drawingRef.current) {
            if (rectangleRef.current) return;
            drawingRef.current = true;
            startPointRef.current = e.latLng;
            rectangleRef.current = new maps.Rectangle({
              map,
              editable: false,
              draggable: false,
              clickable: false,
              strokeWeight: 1,
              fillOpacity: 0.25,
            });
            return;
          }
          drawingRef.current = false;
          rectangleRef.current.setEditable(true);
          rectangleRef.current.setDraggable(true);
          map.setOptions({
            draggableCursor: "grab",
          });
        });

        const moveListener4 = map.addListener("mousemove", (e) => {
          if (!drawingRef.current) return;
          if (!startPointRef.current) return;
          const bounds = new window.google.maps.LatLngBounds();
          bounds.extend(startPointRef.current);
          bounds.extend(e.latLng);
          rectangleRef.current?.setBounds(bounds);
          setDrawnOverlay(rectangleRef.current);
        });

        return () => {
          clickListener4.remove();
          moveListener4.remove();
        };
      default:
        break;
    }
  }, [drawingMode, map, maps, setDrawnOverlay]);

  return (
    <>
      <InfoWindow
        position={positionOfInfoWindow}
        shouldFocus={false}
        minWidth={300}
        headerContent={
          <Typography variant="h6" color="#000">
            {overlaySelected?.CategoryName}
          </Typography>
        }
      >
        <Stack mb={1}>
          <Typography variant="caption">
            ชื่อสถานที่ : {overlaySelected?.LocationName}
          </Typography>
          <Typography variant="caption">
            จำกัดความเร็ว : {overlaySelected?.SpeedLimit ?? "-"} กม./ชม.
          </Typography>
          <Typography variant="caption">
            รัศมี : {overlaySelected?.Radius ?? "-"} เมตร
          </Typography>
        </Stack>
        {overlaySelected?.ImagePath && (
          <Card
            sx={{
              height: 180,
              width: 320,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Image
              src={`${api.imageUrl()}${overlaySelected?.ImagePath}`}
              alt=""
            />
          </Card>
        )}
        {!overlaySelected?.ImagePath && (
          <Image
            width={320}
            height={180}
            src={`/images/unnamed.png`}
            alt=""
            preview={false}
          />
        )}
      </InfoWindow>
      {operation === 2 && (
        <MapControl position={ControlPosition.TOP_LEFT}>
          <TextField
            size="small"
            slotProps={{
              input: {
                sx: {
                  bgcolor: "#FFFFFF",
                  color: "#333333",
                  borderRadius: "4px",
                },
              },
            }}
            sx={{ mt: 1.2 }}
            variant="outlined"
            placeholder="Enter Place"
            onKeyDown={handleKeyDown}
            onChange={(el) => setPosition(el.target.value)}
            autoComplete="off"
            value={position}
          />
        </MapControl>
      )}
    </>
  );
}

export default MapOverlays;
